import jQuery from 'jquery'

export default function initOrientationHelper() {
  jQuery('.no-zoom').bind('touchend', function(e) {
    e.preventDefault();
  })

  jQuery(window).on("orientationchange", function(e) {
    var el = $(".js-comic-book")
    var elOffset = el.offset().top
    var elHeight = el.height()
    var windowHeight = $(window).height()
    var offset

    offset = elOffset - ((windowHeight / 2) - (elHeight / 2))

    if (window.matchMedia("(orientation: portrait)").matches) {
      offset -= 60
    }
    if (window.matchMedia("(orientation: landscape)").matches) {
      offset += 10
    }

    var speed = 700
    setTimeout(function() {
      jQuery('html, body').animate({
        scrollTop: offset
      }, speed)
    }, 300)
  });
}



// WEBPACK FOOTER //
// ./frontend/assets/js/base/orientation.js